import { CreateParallaxables } from '../src/components/Parallax.jsx';

const properties = new Map([
  ['rotate.x', (target, _, value) => (target.rotate.x = value)],
  ['rotate.y', (target, _, value) => (target.rotate.y = value)],
  ['rotate.z', (target, _, value) => (target.rotate.z = value)],
  ['position.x', (target, _, value) => (target.position.x = value)],
  ['position.y', (target, _, value) => (target.position.y = value)],
  ['position.z', (target, _, value) => (target.position.z = value)],
  ['scale.x', (target, _, value) => (target.scale.x = value)],
  ['scale.y', (target, _, value) => (target.scale.y = value)],
  ['scale.z', (target, _, value) => (target.scale.z = value)],
]);

const apply = (target, property, value) => (target[property] = value);

const dynamicApply = (target, property, value) => {
  let tar = target;
  const properties = property.split('.');
  for (let idx = 0; idx < properties.length - 1; idx++) {
    tar = tar[properties[idx]];
  }

  tar[properties[properties.length - 1]] = value;
};

export default CreateParallaxables({
  name: 'Three',
  update(target, { animations }) {
    for (const { property, currentValue } of animations) {
      const fn = properties.get(property) ?? 
        property.includes('.') ? dynamicApply : apply;
      fn(target, property, currentValue);
    }
  },
});